import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'logState';

export const postLogData = createAsyncThunk(
    'logState/postLogData',
    async ({ operation, deviceId, logData }, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${config.server}/api/logs?operation=${operation}&deviceId=${deviceId}`,
                data: logData,
                withCredentials: true,
                auth: createAuth(getState)
            });
            return response.data;
        } catch (error) {
            console.log('ERROR PUSHING LOGDATA', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    status: 'idle',
    error: null,
};

const logSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //postLogData
            .addCase(postLogData.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(postLogData.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(postLogData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default logSlice.reducer;